import { FC } from 'react';
import { Select, SelectProps } from 'view/component/Select/Select';
import { SelectOption } from 'view/component/Select/SelectItem';


export enum RestricaoUnidade {
  BUSCA_SOMENTE_DESTA_UNIDADE = 1,
  BUSCA_ESTA_UNIDADE_E_SUB_UNIDADES = 2,
}


export const RestricaoUnidadeSelect: FC<SelectProps> = props => {
  const opcoes: SelectOption[] = [
    { 'value': RestricaoUnidade.BUSCA_SOMENTE_DESTA_UNIDADE, 'label': 'Exatamente nesta unidade'},
    { 'value': RestricaoUnidade.BUSCA_ESTA_UNIDADE_E_SUB_UNIDADES, 'label': 'Esta unidade e em suas subunidades'},
  ]

  return <Select
    {...props}
    isClearable={false}
    placeholder="Selecione uma situação"
    defaultValue={opcoes[1]}
    options={opcoes}
  />
}